<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 500"
    maxFiles="12"
    maxFilesShow="12"
    :on-save="onSave"
  >
    <v-form class="d-grid gap-5" v-model="valid" ref="form" lazy-validation>
      <BaseInput
        type="select"
        :label="localStorage.translations.pages['setting-personal_area'].labels['obuv']"
        :view="!editing"
        v-model="clothesSizesData.size_shoes"
        :items="shoesList"
        append-icon="fas fa-angle-down"
      />
      <BaseInput
        type="select"
        :label="localStorage.translations.pages['setting-personal_area'].labels['kurtka']"
        :view="!editing"
        v-model="clothesSizesData.size_jacket"
        :items="jacketList"
        append-icon="fas fa-angle-down"
      />
      <BaseInput
        type="select"
        :label="localStorage.translations.pages['setting-personal_area'].labels['shtany']"
        :view="!editing"
        v-model="clothesSizesData.size_pants"
        :items="pantsList"
        append-icon="fas fa-angle-down"
      />
      <BaseInput
        type="select"
        :label="localStorage.translations.pages['setting-personal_area'].labels['perchatki']"
        :view="!editing"
        v-model="clothesSizesData.size_gloves"
        :items="glovesList"
        append-icon="fas fa-angle-down"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'ClothesSizes',
  props: {
    editing: Boolean,
    clothesSizes: Object,
    employeeId: Number,
    onSave: Function,
    modal: Boolean,
  },
  components: { PersonalAreaTemplate },
  data: () => ({
    valid: false,
    clothesSizesData: {
      size_shoes: '',
      size_jacket: '',
      size_pants: '',
      size_gloves: '',
    },
    shoesList: ['38', '39', '40', '41', '42', '43', '44', '45', '46', '47'],
    jacketList: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    pantsList: [
      '40',
      '41',
      '42',
      '43',
      '44',
      '45',
      '46',
      '47',
      '48',
      '49',
      '50',
      '51',
      '52',
      '53',
      '54',
      '55',
      '56',
      '57',
      '58',
      '59',
      '60',
    ],
    glovesList: ['8', '9', '10', '11'],
  }),
  watch: {
    clothesSizes() {
      this.onActualData()
    },
    clothesSizesData: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { clothesSizesData: this.clothesSizesData },
          overwrite: false,
        })
      },
    },
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    validate() {
      return this.$refs.form.validate()
    },
    onActualData() {
      if (this.clothesSizes) {
        this.clothesSizesData.size_shoes = this.clothesSizes.size_shoes
        this.clothesSizesData.size_jacket = this.clothesSizes.size_jacket
        this.clothesSizesData.size_pants = this.clothesSizes.size_pants
        this.clothesSizesData.size_gloves = this.clothesSizes.size_gloves
      }
      this.onNavigationGuardianCheck({
        data: { clothesSizesData: this.clothesSizesData },
        overwrite: true,
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.validate()) {
          if (this.$checkNavigationGuardianChange('clothesSizesData')) {
            let data = {
              size_shoes: this.clothesSizesData.size_shoes,
              size_jacket: this.clothesSizesData.size_jacket,
              size_pants: this.clothesSizesData.size_pants,
              size_gloves: this.clothesSizesData.size_gloves,
            }
            resolve(data)
          } else resolve(true)
        } else reject(false)
      })
    },
  },
}
</script>
